/**
 * @module Locker
 * @desc Simple icon and style for displaying a lock or unlock icon inside an avatar.
 */

import { Avatar } from '@mui/material';
import { lighten, styled } from '@mui/system';
import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';

type LockerProps = {
    locked: boolean;
};

const StyAvatar = styled(Avatar, {
    name: 'StyAvatar',
    shouldForwardProp: (prop) => prop !== 'locked',
})<{ locked: boolean }>(({ locked, theme }) => ({
    height: '30px',
    width: '30px',
    backgroundColor: locked
        ? lighten(theme.palette.orange, 0.8)
        : lighten(theme.palette.green, 0.8),
    color: locked ? theme.palette.orange : theme.palette.green,
    borderColor: locked ? theme.palette.orange : theme.palette.green,
    borderStyle: 'solid',
    borderWidth: '1px',
}));

/**
 * Simple icon for displaying a lock or unlock icon inside a circle.
 * @param props
 * @returns
 */
export const Locker = (props: LockerProps) => (
    <StyAvatar locked={props.locked}>
        {props.locked ? <LockOutlinedIcon /> : <LockOpenOutlinedIcon />}
    </StyAvatar>
);
